<div class="card-message" [class.card-message-bg-color]="!(compact || back)" [class.card-muted]="muted" [class.card-compact]="compact">
    <div i18n class="card-message-text" [class.card-message-textonly]="textOnly">
        @switch (cardState) {
            @case (CardState.MessageFaceDown) {
                Face down card
            }
            @case (CardState.MessageFaceUp) {
                Face up card
            }
            @case (CardState.MessageFlipCard) {
                Flip card on table
            }
        }
    </div>
    @if (!textOnly) {
        @if (back) {
            <div class="card-message-image card-message-back"></div>
        } @else {
            <div class="card-message-image card-message-symbols"></div>
        }
    }
</div>
